import React from 'react';

import './base-modal.scss';

const BaseModal = ({ options, isShowing = true }) => {
  if (!isShowing) return null;

  const displayMsg = options.displayMsg ? <h1>{options.displayMsg}</h1> : null;

  const displayTxt = options.displayTxt ? <h2>{options.displayTxt}</h2> : null;

  const saveBtn = options.save ? (
    <button className="save-btn" onClick={options.save.callback}>
      {options.save.txt}
    </button>
  ) : null;

  const cancelBtn = options.cancel ? (
    <button className="cancel-btn" onClick={options.cancel.callback}>
      {options.cancel.txt}
    </button>
  ) : null;

  const saveAndCancelBtns = ['confirm-enable-recon', 'confirm-disable-recon'].includes(
    options.identifier,
  ) ? (
    <>
      {cancelBtn}
      {saveBtn}
    </>
  ) : (
    <>
      {saveBtn}
      {cancelBtn}
    </>
  );

  return (
    <div className="base-modal-container">
      <div className={`base-modal ${options.identifier}`}>
        {displayMsg}
        {displayTxt}
        {saveAndCancelBtns}
      </div>
    </div>
  );
};

export default BaseModal;
